import type { ComponentProps } from 'react'
import { useCallback, useEffect, useState } from 'react'

import { SpendLimitation } from '@/modules/expiring-fans/components/spend-limitation.tsx'
import { useDebouncedProperty } from '@/utils/useDebouncedProperty.ts'

interface Props extends ComponentProps<'div'> {
  maxSpend: number
  changeMaxSpend: (value: number | null) => void
  disabled?: boolean
}

export const SpendLimitationController = ({
  maxSpend,
  changeMaxSpend,
  disabled,
  ...props
}: Props) => {
  const [currentMaxSpend, setMaxSpend] = useDebouncedProperty<number | null>(
    maxSpend,
    changeMaxSpend,
    1200,
  )
  const [enabled, setEnabled] = useState(!!maxSpend)

  const onToggle = useCallback(() => {
    setEnabled((state) => {
      const newState = !state

      if (!newState) {
        setMaxSpend(null)
      } else {
        setMaxSpend(1)
      }

      return newState
    })
  }, [setEnabled, setMaxSpend])

  useEffect(() => {
    setEnabled(!!maxSpend)
  }, [maxSpend])

  return (
    <SpendLimitation
      {...props}
      value={currentMaxSpend}
      onValueChange={(event) => setMaxSpend(event.target.valueAsNumber)}
      enabled={enabled}
      onToggle={onToggle}
      textFieldClassName="max-w-[8rem]"
      disabled={disabled}
    />
  )
}
